define('viewmodels/modals/alerts/ChoiceAlert',['underscore'], function (_) {

    var BUTTON_STYLES = 'button full-width ';

    var Choice = function(id, text, button) {
        var self = this;

        self.id = id;
        self.text = text;
        self.button = BUTTON_STYLES + button;
    };

    var ChoiceAlert = function (dialog, title, message, choices) {
        var self = this;

        self.title = title;
        self.message = message;
        self.choices = _.map(choices, function(choiceObj) {
            return new Choice(choiceObj.id, choiceObj.text, choiceObj.button);
        });

        /**
         * Closes the ChoiceAlert and resolves the dialog promise with the choiceId
         * @param choiceId The id that the dialog promise is resolved with
         */
        self.close = function (choiceId) {
            dialog.getDialog(self).close(choiceId);
        };

        self.show = function() {
            return dialog.showAlert(self);
        };
    };

    /**
     * Creates a new choice
     * @param id The id that the dialog promise is resolved with if this choice is chosen
     * @param text Choice button text
     * @param button Choice button type (className)
     * @returns {Choice}
     */
    ChoiceAlert.prototype.createChoice = function (id, text, button) {
        this.choices.push(new Choice(id, text, button));
    };

    return ChoiceAlert;
});

